module.exports = __webpack_public_path__ + "static/media/activity-improvement.8b5e6a9d.svg";